import { bdrMonthlyExpiryDatesRequested } from 'state/monthlyExpiryDates/monthlyExpiryDates.action';
import type { Thunk } from 'state/state.common';

export function checkMonthlyExpiryCalendarsRequestNeededThunk(calendars: string[]): Thunk<void> {
  return (
    dispatch,
    getState,
    {
      selectors: {
        monthlyExpiryDatesSelector: { getUnknownMonthlyExpiryCalendars },
      },
    },
  ) => {
    if (!Array.isArray(calendars) || calendars.length === 0) {
      return;
    }

    const unknownMonthlyExpiryDateCalendars = getUnknownMonthlyExpiryCalendars(getState(), calendars);
    if (unknownMonthlyExpiryDateCalendars.length === 0) {
      return;
    }
    dispatch(bdrMonthlyExpiryDatesRequested(unknownMonthlyExpiryDateCalendars));
  };
}
